var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "basicSettingsSEO"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    staticStyle: {
      "border-bottom": "24px solid #f0f2f5",
      "margin-top": "24px"
    },
    attrs: {
      model: _vm.dataForm
    }
  }, [_c("a-tabs", {
    attrs: {
      type: "card",
      activeKey: _vm.tabKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_vm._l(_vm.dataForm.seoList, function (item, index) {
    return [_c("a-tab-pane", {
      key: item.langId,
      attrs: {
        tab: item.languageName
      }
    }, [_c("a-card", {
      attrs: {
        bordered: false
      }
    }, [_c("a-row", [_c("a-col", {
      attrs: {
        span: 16
      }
    }, [_c("a-form-model-item", [_c("span", {
      attrs: {
        slot: "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t("basicSettings.emailNotifySetting.title")) + " "), _c("a-tooltip", {
      attrs: {
        placement: "topLeft",
        title: _vm.$t("basicSettings.emailNotifySetting.tooltip")
      }
    }, [_c("a-icon", {
      attrs: {
        type: "info-circle"
      }
    })], 1)], 1), _c("a-textarea", {
      staticStyle: {
        display: "inline-block",
        width: "800px"
      },
      attrs: {
        rows: 10,
        allowClear: ""
      },
      model: {
        value: _vm.dataForm.seoList[index].content,
        callback: function callback($$v) {
          _vm.$set(_vm.dataForm.seoList[index], "content", $$v);
        },
        expression: "dataForm.seoList[index].content"
      }
    })], 1)], 1)], 1)], 1)], 1)];
  })], 2), _c("a-form-model-item", [_c("a-button", {
    staticStyle: {
      "margin-left": "24px",
      "margin-bottom": "18px"
    },
    attrs: {
      loading: _vm.loadingSave,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")))])], 1)], 1), _c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("StandardTableVue", {
    attrs: {
      columns: _vm.columns,
      dataSource: _vm.data,
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "showOrder",
      fn: function fn(_ref) {
        var text = _ref.text,
          index = _ref.index;
        return _c("span", {}, [_vm._v(" " + _vm._s(index + 1) + " ")]);
      }
    }, {
      key: "switchStatus",
      fn: function fn(_ref2) {
        var text = _ref2.text;
        return _c("span", {}, [_c("a-tag", {
          attrs: {
            color: text === 0 ? "red" : "blue"
          }
        }, [_vm._v(" " + _vm._s(text == 0 ? _vm.$t("disabled") : _vm.$t("Enable")) + " ")])], 1);
      }
    }, {
      key: "action",
      fn: function fn(_ref3) {
        var record = _ref3.record;
        return _c("span", {}, [_c("a-popconfirm", {
          attrs: {
            title: record.switchStatus == 0 ? _vm.$t("EnableMessage") : _vm.$t("disabledMessage"),
            "ok-text": _vm.$t("yes"),
            "cancel-text": _vm.$t("no"),
            getPopupContainer: function getPopupContainer(triggerNode) {
              return triggerNode.parentElement;
            }
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirm(record);
            },
            cancel: _vm.cancel
          }
        }, [_c("a", [_vm._v(_vm._s(record.switchStatus == 0 ? _vm.$t("Enable") : _vm.$t("disabled")))])]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-dropdown", [_c("a", {
          staticClass: "ant-dropdown-link",
          on: {
            click: function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("preView"))), _c("a-icon", {
          attrs: {
            type: "down"
          }
        })], 1), _c("a-menu", {
          attrs: {
            slot: "overlay"
          },
          slot: "overlay"
        }, _vm._l(_vm.dataForm.seoList, function (item) {
          return _c("a-menu-item", {
            key: item.langId
          }, [_c("a", {
            attrs: {
              href: "javascript:;"
            },
            on: {
              click: function click($event) {
                return _vm.notifyPreviewMethod(record, item.langId);
              }
            }
          }, [_vm._v(_vm._s(item.languageName))])]);
        }), 1)], 1)], 1);
      }
    }])
  }), _c("a-modal", {
    attrs: {
      footer: null,
      visible: _vm.showHtml,
      width: "800px"
    },
    on: {
      cancel: _vm.canacelHtml
    }
  }, [_c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.html)
    }
  })])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };